import { EgretLoadable } from "egret";



const adminAccountSettingsManagment = EgretLoadable({
  loader: () => import("./AdminAccountSettings")
});

const adminEditSettingsManagment = EgretLoadable({
  loader: () => import("./AdminEmailSettings")
});

const liveChatSettings = EgretLoadable({
  loader: () => import("./LiveChatSettings")
});
 

const adminSettingsRoutes = [ 
  {
    path: "/agentAccountSettings",
    component: adminAccountSettingsManagment
  },
  {
    path: "/agentEmailSettings",
    component: adminEditSettingsManagment
  },
  {
    path: "/liveChatSnippet",
    component: liveChatSettings
  }
];
 
export default adminSettingsRoutes;
